import { addition } from "./count";

// 常用正则
const regularObj = {
  // '格式错误' : 'format error'
  email: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/,
  // '支持数字' : 'Support digital'
  phone: /^\d+$/,
  // '支持长度为4位或6位的数字' : 'The value can contain four or six digits'
  vcode: /^\d{4}|\d{6}$/,
  // '支持8-16位数字和字母的组合' : 'Supports the combination of 8 to 16 digits and letters'
  password: /^(?=.*[0-9\!@#\$%\^&\*])(?=.*[a-zA-Z]).{8,16}$/,
  // '支持字母和空格组成' : 'Letters and Spaces are supported'
  enName: /^[A-Za-z]*(\s[A-Za-z]*)*$/,
  // '支持英文' : 'Support English' (只能输入半角字符)
  english: /^[\x00-\xff]*$/,
};
export { regularObj };

// 表单验证快速定位
export function validateLocation(object, that) {
  for (const i in object) {
    let dom = that.$refs[i];
    // 这里是针对遍历的情况（多个输入框），取值为数组
    if (Object.prototype.toString.call(dom) !== "[object Object]") {
      dom = dom[0];
    }
    // 第一种方法（包含动画效果）
    dom.$el.scrollIntoView({
      // 滚动到指定节点
      block: "center", // 值有start,center,end，nearest，当前显示在视图区域中间
      behavior: "smooth", // 值有auto、instant,smooth，缓动动画（当前是慢速的）
    });
    break;
  }
}

// 表单校验失败时，基于 el-form 实例的 fields 定位到第一个失败字段
// 与 validateLocation 的区别：formRef.fields 仅含"当前表单"的字段，
// 可规避多 tab / 多表单下同名 $refs 冲突导致的定位错乱
export function validateFormLocation(object, formRef) {
  if (!object || !formRef || !formRef.fields) return;
  const failedKeys = Object.keys(object);
  const failedField = formRef.fields.find(f => failedKeys.includes(f.prop));
  if (failedField && failedField.$el) {
    failedField.$el.scrollIntoView({
      block: "center", // 滚动到视图区域中间
      behavior: "smooth", // 缓动动画
    });
  }
}

// 滚动到指定的ref位置
export function scrollToRef(refName, that) {
  const dom = that.$refs[refName];
  if (dom) {
    // 如果是 Vue 组件，使用 dom.$el；如果是原生 DOM，直接使用 dom
    const targetElement = dom.$el || dom;
    // 确保找到了真实的 HTML 元素后再执行滚动
    if (targetElement && typeof targetElement.scrollIntoView === "function") {
      targetElement.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    } else {
      console.warn(`无法在 ref "${refName}" 上执行 scrollIntoView`);
    }
  } else {
    console.warn(`未找到对应的 ref: "${refName}"`);
  }
}

// 对象数组，相同属性合并，并相加
export function mergeArr(arr, key, nub) {
  var newArr = [];
  arr.forEach(item => {
    if (item[key]) {
      var dataItem = item;
      if (newArr.length > 0) {
        var filterValue = newArr.filter(v => {
          return v[key] == dataItem[key];
        });
        if (filterValue.length > 0) {
          newArr.forEach(n => {
            if (n[key] == filterValue[0][key]) {
              const unit01 = filterValue[0][nub] && parseFloat(filterValue[0][nub]) ? parseFloat(filterValue[0][nub]) : 0;
              const unit02 = dataItem[nub] && parseFloat(dataItem[nub]) ? parseFloat(dataItem[nub]) : 0;
              n[nub] = addition(unit01, unit02);
            }
          });
        } else {
          newArr.push(dataItem);
        }
      } else {
        newArr.push(dataItem);
      }
    }
  });
  return newArr;
}

// 获得table表格的高度, minus(需要减去的高度)
export function tableHeight(minus) {
  const clientHeight = document.documentElement.clientHeight;
  const clientHeightCopy = clientHeight < 720 ? 720 : clientHeight;
  return clientHeightCopy - minus;
}

// 生成uuid
export function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0;
    var v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// 检查是否为数字或数字字符串
export function isNumberLike(val) {
  // 排除 null, undefined, boolean, Symbol 等非目标类型
  if (val === null || val === undefined || typeof val === "boolean" || typeof val === "symbol") {
    return false;
  }
  // 排除数组和对象（防止 [123] 被误判）
  if (typeof val === "object") return false;
  // 排除空字符串或全是空格的字符串
  if (typeof val === "string" && val.trim() === "") return false;
  // 利用 Number() 的严格转换特性
  // Number() 转换 "12px" 会得到 NaN，而parseFloat会得到12
  const n = Number(val);
  return !isNaN(n) && isFinite(n);
}

// 将字符串数字转成数字
export function strToNum(val) {
  if (isNumberLike(val)) {
    return Number(val);
  } else {
    return null;
  }
}

// 从数据源中获取表单需要的数据
export function getFormDataFromSource(dataSource, dataForm) {
  // 定义不想被覆盖的“黑名单”字段
  const ignoreFields = ["id"];
  // 浅拷贝原表单，保留初始状态（包括原有的id等）
  const source = dataSource;
  const newDataForm = { ...dataForm };
  // 只挑选dataForm已有的属性进行copy
  Object.keys(newDataForm).forEach(key => {
    // 逻辑：既不在黑名单中，且源数据中确实存在该属性
    if (!ignoreFields.includes(key) && key in source) {
      newDataForm[key] = source[key];
    }
  });
  return newDataForm;
}
